module.exports = __webpack_public_path__ + "public/img/agile_1.589b2185.png";